// extracted by mini-css-extract-plugin
module.exports = {"total":"PacksCount_total__E8WUv","total--loading":"PacksCount_total--loading__MZdMB","total__beds":"PacksCount_total__beds__2UgOR"};